<mat-expansion-panel [expanded]="startExpanded">
    <mat-expansion-panel-header>
        {{title}}
        <span *ngIf="visibleElementsCount" class="ml-1">({{visibleElementsCount}})</span>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
        <div *ngIf="searchEnabled || grouping">
            <mat-form-field *ngIf="searchEnabled">
                <mat-label>{{ 'search' | translate }}</mat-label>
                <input matInput [(ngModel)]="filterValue" (keyup)="applyFilter($event.target.value)" tabindex="-1" autocomplete="off">
                <button mat-button mat-icon-button matSuffix *ngIf="filterValue.length > 0"
                        attr.aria-label="{{ 'clear' | translate}}" matTooltip="{{ 'clear' | translate}}"
                        (click)="$event.stopPropagation(); clearSearchInput()">
                    <mat-icon svgIcon="close"></mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field *ngIf="grouping" class="ml-4">
                <mat-label>{{ 'groupData' | translate }}</mat-label>
                <mat-select [(value)]="selectedGroup" (selectionChange)="groupChanged()">
                    <mat-option>{{ 'doNotGroup' | translate }}</mat-option>
                    <mat-option *ngFor="let group of grouping" [value]="group">{{ group | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="elementClick.next(node.data)">
                <!-- add padding class to provide padding for tree leaf -->
                <div class="width-100p pl-4 pr-4">
                    <app-tree-item [node]="node"></app-tree-item>
                </div>
            </mat-tree-node>

            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                <div matTreeNodeToggle>
                    <button mat-icon-button [attr.aria-label]="'toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror" svgIcon="{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}">
                        </mat-icon>
                    </button>
                    {{ (node.name) | translate }} ({{node.elements}})
                </div>
            </mat-tree-node>
        </mat-tree>
    </ng-template>
</mat-expansion-panel>
